/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/13
 * @updateTime 2021/8/13
 * @decription 一键申请保全模块入口js
 */
// 标题
import MyTitle from '../../../components/common/myTitle';
// 基本信息
import BasicInfo from './basic-info/index.vue';
// 申请人
import Proposer from './proposer/index.vue';
// 被申请人
import Respondent from './respondent/index.vue';
// 原告代理人
import Accuser from './accuser/index.vue';
// 财产线索
import CCXS from './ccxs/index.vue';
// 证据信息
import ZJXX from './zjxx/index.vue';
// 行为信息
import XWXX from './xwxx/index.vue';
// 担保信息
import DBXX from './dbxx/index.vue';
// 上传材料
import SCCL from './sccl/index.vue';
// 一键申请保全
import {submitBqsqOneKey} from '../../../api/common'
export default {
    name: 'appCompGuaranteeOneKey',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        MyTitle,
        BasicInfo,
        Proposer,
        Respondent,
        Accuser,
        CCXS,
        ZJXX,
        XWXX,
        DBXX,
        SCCL
    },
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-guarantee-on-key'
            },
            // 是否显示财产线索
            isShowCcsx: false,
            // 是否显示原告代理人
            isShowAccuser: false,
            // 是否显示上传材料
            isShowSCCL: false,
            // 基本信息
            basicData: null,
            // 申请人数据
            sqrData: [],
            // 被申请人数据
            bsqrData: [],
            // 是否正常退出
            isNormalExit: false
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 离开判断如果非正常退出，则需要删除对应的一键保全记录
    beforeRouteLeave (to, from, next) {
        // 导航离开该组件的对应路由时调用
        // 可以访问组件实例 `this`
        // 如果是点击返回或者点击home键，则进行一键保全记录的删除
        if (!this.isNormalExit) {
            // 请求删除一键保全记录
            this.requestDelRecord().then(() => {
                console.log('删除成功！');
            });
        }
        next();
    },
    // 方法
    methods: {
        /**
         * 点击取消
         * @returns {void}
         * */
        eClickCancel() {
            // 是正常退出
            this.isNormalExit = true;
            // 删除对应的记录
            this.requestDelRecord().then(() => {
                this.$router.go(-1);
            })
        },

        /**
         * 请求删除保全记录
         * @returns {Promise}
         * */
        requestDelRecord() {
            return this.$axios.delete('/ssbq/api/bqsq/del?bqid=' + sessionStorage.getItem('bqid'));
        },

        /**
         * 点击提交
         * @returns {void}
         * */
        eClickSubmit() {
            // 是正常退出
            this.isNormalExit = true;
            submitBqsqOneKey({id: sessionStorage.getItem('bqid')}).then(() => {
                // 返回上一个页面
                this.$router.go(-1);
            }).catch((err) => {
                console.log(err)
            })
        },

        /**
         * 基本信息加载完成
         * @param {Object} basicData 基本信息数据
         * @returns {void}
         * */
        basicInfoLoaded(basicData) {
            this.basicData = basicData;
            // 显示上传材料
            this.isShowSCCL = true;
        },

        /**
         * 申请人加载完成
         * @param {Object} sqrData 申请人数据
         * @returns {void}
         * */
        proposerLoaded(sqrData) {
            this.sqrData = sqrData;
            // 显示申请人
            this.isShowAccuser = true;
        },

        /**
         * 被申请人加载完成
         * @param {Object} bsqrData 被申请人数据
         * @returns {void}
         * */
        respondentLoaded(bsqrData) {
            this.bsqrData = bsqrData;
            // 显示财产线索
            this.isShowCcsx = true;
        }
    }
};
